import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Card,
  Button,
  Form,
} from "react-bootstrap";
import { MdOutlineMail } from "react-icons/md";
import { FiGlobe } from "react-icons/fi";
import { FiPhone, FiMapPin } from "react-icons/fi";
import ReCAPTCHA from "react-google-recaptcha";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { RiGlobalLine } from "react-icons/ri";
import { FiPhoneCall } from "react-icons/fi";
import styles from "./ContactAbout.module.css";

export default function ContactAbout() {
  const [verified, setVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setVerified(true); // reCAPTCHA passed
    } else {
      setVerified(false); // reCAPTCHA cleared or expired
    }
  };

  const offices = [
    {
      title: "Head Office",
      location:
        "Babuganj, Land mark-Manupankhi Ghat, Jagannath Ghat Lane Chinsurah, West Bengal 712103",
    },
    {
      title: "Registered Office",
      location:
        "#1 Pearabagan Road Near Wholesale Co-Operative, Po & Dist-Hoohly 712103",
    },
    {
      title: "Branch Office",
      location:
        "1/12 A Neheru Colony PO,Regent Park Kolkata West Bengal 700040",
    },
  ];

  return (
    <Container>
      <br></br>
      <h3 style={{ fontFamily: "'Inter', sans-serif", fontWeight: "bold" }}>
        About Us
      </h3>
      <Row>
        <Col>
          <Image
            src="https://synergisw.co.uk/wp-content/uploads/2021/05/20210412-JA3_8572-scaled.jpg"
            style={{ width: "100%", borderRadius: 20 }}
          />
        </Col>
        <Col>
          <p>
            Lorem Ipsum has been the industry's standard dummy text ever since
            the 1500s, when an unknown printer took a galley of type and
          </p>
        </Col>
      </Row>
      <Row className="justify-content-center my-1">
        <Col md={12} lg={6}>
          <Card className=" border-0 rounded-4">
            <Card.Body className="p-4 p-md-5">
              <h3
                className="text-center mb-4"
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "700",
                  color: "#212529",
                }}
              >
                Message Us
              </h3>

              <Form>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Control
                    type="text"
                    placeholder="Your Name"
                    style={{fontSize:17}}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPhone">
                  <Form.Control
                    type="text"
                    placeholder="Phone Number"
                   style={{fontSize:17}}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Control
                    type="email"
                    placeholder="Email Address"
                     style={{fontSize:17}}
                  />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formMessage">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Your Message"
                    style={{ resize: "none",fontSize:17 }}
                  
                  />
                </Form.Group>

                <div className="d-flex justify-content-center mb-4">
                  <ReCAPTCHA
                    sitekey="6Lcv2aMrAAAAABFz2tVGCJQJX98zkXGnBV9zzg8O"
                    onChange={handleCaptchaChange}
                  />
                </div>

                <div className="d-grid">
                  <Button
                    variant="dark"
                    type="submit"
                    className="py-2 fs-5 fw-bold rounded-pill"
                  >
                    Send Message
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <br></br>

      <div>
         <h3
    style={{
      fontFamily: "'Inter', sans-serif",
      fontWeight: "bold",
      color: "#07448E",
      textAlign:"center"
    }}
  >
    Contact Us
  </h3>
        <Row className="justify-content-center mt-4 g-4">
    <Col xs={12} sm={6} md={4} lg={3}>
      <div className="d-flex align-items-center justify-content-center p-3 border rounded-3 shadow-sm bg-white">
        <MdOutlineEmail size={24} color="#07448E" className="me-3" />
        <div>
          <h6 className="mb-1 fw-semibold text-dark">Email</h6>
          <small className="text-muted">info@gmail.com</small>
        </div>
      </div>
    </Col>

    <Col xs={12} sm={6} md={4} lg={3}>
      <div className="d-flex align-items-center justify-content-center p-3 border rounded-3 shadow-sm bg-white">
        <RiGlobalLine size={24} color="#07448E" className="me-3" />
        <div>
          <h6 className="mb-1 fw-semibold text-dark">Website</h6>
          <small className="text-muted">www.example.com</small>
        </div>
      </div>
    </Col>

    <Col xs={12} sm={6} md={4} lg={3}>
      <div className="d-flex align-items-center justify-content-center p-3 border rounded-3 shadow-sm bg-white">
        <FiPhoneCall size={24} color="#07448E" className="me-3" />
        <div>
          <h6 className="mb-1 fw-semibold text-dark">Phone</h6>
          <small className="text-muted">+91 8574541512</small>
        </div>
      </div>
    </Col>
  </Row>
      
       <Row className="justify-content-center g-4 mt-5" style={{fontFamily: "'Poppins', sans-serif"}}>
    {offices.map((office, index) => (
      <Col
        key={index}
        xs={12}
        sm={6}
        md={4}
        lg={3}
        className="d-flex align-items-stretch justify-content-center"
      >
        <div
          className="p-4 border rounded-3 shadow-sm w-100"
          style={{
            backgroundColor: "#fff",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)";
          }}
        >
          <h5 className="fw-semibold mb-2 text-primary" style={{fontSize:16}}>{office.title}</h5>
          <p className="mb-0 text-muted" style={{color:"#000",fontSize:12}}>{office.location}</p>
        </div>
      </Col>
    ))}
  </Row>
        <div className="d-none d-md-block text-center mt-5">
          <h4
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Follow Us
          </h4>

          <div className="d-flex justify-content-center gap-3">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center justify-content-center rounded-circle bg-light text-secondary"
              style={{
                width: "50px",
                height: "50px",
                fontSize: "20px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1877f2"; // Facebook blue
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.color = "gray";
              }}
            >
              <FaFacebookF />
            </a>

            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center justify-content-center rounded-circle bg-light text-secondary"
              style={{
                width: "50px",
                height: "50px",
                fontSize: "20px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1DA1F2"; // Twitter blue
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.color = "gray";
              }}
            >
              <FaTwitter />
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center justify-content-center rounded-circle bg-light text-secondary"
              style={{
                width: "50px",
                height: "50px",
                fontSize: "20px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#E1306C"; // Instagram pink
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.color = "gray";
              }}
            >
              <FaInstagram />
            </a>

            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center justify-content-center rounded-circle bg-light text-secondary"
              style={{
                width: "50px",
                height: "50px",
                fontSize: "20px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#0A66C2"; // LinkedIn blue
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.color = "gray";
              }}
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
}
